import { SELLER_PAYOUT_HOURS } from "@/lib/businessDays";
import LiveCountdown from "@/components/shared/LiveCountdown";

/** Sous-ligne liste (Mes achats / Mes ventes) avec décompte live du délai sécurité. */
export default function TrackingListSubline({ tracking, role, tx }) {
  if (!tracking) return null;

  const parts = [tracking.pipeline_label, tracking.money_location_label].filter(Boolean);
  if (role === "buyer" && tracking.buyer_access === "locked") {
    parts.push("coordonnées masquées");
  }

  const unique = parts.filter((p, i, arr) => arr.indexOf(p) === i);
  const base = unique.join(" · ");

  const payoutIso =
    role === "seller" && tx?.seller_payout_available_at && !tx?.stripe_connect_transfer_id
      ? tx.seller_payout_available_at
      : null;
  const disputeIso =
    role === "buyer" && tracking.dispute_window_ends_at && tracking.hours_until_dispute_end > 0
      ? tracking.dispute_window_ends_at
      : null;

  const countdownIso = payoutIso || disputeIso;
  if (!countdownIso) return base || null;

  return (
    <span>
      {base ? `${base} · ` : ""}
      Délai {SELLER_PAYOUT_HOURS} h :{" "}
      <LiveCountdown targetIso={countdownIso} prefix="" doneLabel="échu" />
    </span>
  );
}
